export const MATIC_CARE_ADD_ON_OPEN_EVENT = "matic-care-addon:open";
export const MATIC_CARE_ADD_ON_HASH = "#matic-care-addon";
export const MATIC_CARE_ADD_ON_ID = "matic-care-addon";
